import jwtAuthAxios from "../auth/jwtAuth";
import { setBackendDomain } from "./management";

const normalizeId = (val) => {
  if (val === null || val === undefined) return "";
  return String(val).trim();
};

export const getUsers = async ({ page = 1, limit = 20 } = {}) => {
  setBackendDomain(jwtAuthAxios);
  const params = {
    page: Number(page) || 1,
    limit: Number(limit) || 20,
  };
  const { data } = await jwtAuthAxios.get(`/api/v1/users`, { params });
  return data;
};

export const getUserById = async (userId) => {
  setBackendDomain(jwtAuthAxios);
  const safeId = encodeURIComponent(normalizeId(userId));
  const { data } = await jwtAuthAxios.get(`/api/v1/users/${safeId}`);
  return data;
};

export const deleteUserById = async (userId) => {
  setBackendDomain(jwtAuthAxios);
  const safeId = encodeURIComponent(normalizeId(userId));
  const { data } = await jwtAuthAxios.delete(`/api/v1/users/${safeId}`);
  return data;
};

export const createUser = async (payload) => {
  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.post(`/api/v1/users`, payload);
  return data;
};

export const updateUserById = async (userId, payload) => {
  setBackendDomain(jwtAuthAxios);
  const safeId = encodeURIComponent(normalizeId(userId));
  const { data } = await jwtAuthAxios.put(`/api/v1/users/${safeId}`, payload);
  return data;
};

